/**
 * @module Utilities/Dom
 * @desc Dom helper funtions
 */

import scroll from 'scroll';

import type { ScrollTop } from './dom';

/**
 * Get the offset height of the target element
 */
export function getTargetTop(targetTop: number): number {
  const header = document.querySelector('header');

  if (header instanceof HTMLElement) {
    return targetTop - header.offsetHeight;
  }

  return 0;
}

/**
 * Get scroll element
 */

function scrollDoc() {
  return (document.scrollingElement as HTMLElement) || document.documentElement;
}

/**
 * Set scroll position
 */
export function scrollTop(top = 0, options: ScrollTop = {}) {
  return new Promise<void>((resolve, reject) => {
    const { animate, duration, includeHeader, scrollElement } = {
      animate: false,
      duration: 400,
      scrollElement: scrollDoc(),
      ...options,
    };
    const targetTop = includeHeader ? getTargetTop(top) : top;

    if (animate) {
      scroll.top(scrollElement, targetTop, { duration }, (err) => {
        if (err && err.message !== 'Element already at target scroll position') {
          reject(err);

          return;
        }

        resolve();
      });
    } else {
      window.scrollTo(0, targetTop);
      resolve();
    }
  });
}
